/// <amd-module name="Agile/Common/Redux/HubTeam/HubTeamModule" />
import { IModule } from "redux-dynamic-modules";
import { hubTeamReducer } from "Agile/Common/Redux/HubTeam/HubTeamReducer";
import { IHubTeamAwareState } from "Agile/Common/Redux/HubTeam/HubTeamContracts";
/** This module doesn't load its state using saga. It just maintains the ITeam which can be seeded by a hub*/
export const HubTeamModule: IModule<IHubTeamAwareState> = { id: "hub-team-module", reducerMap: { hubteamState: hubTeamReducer } };
